// buildCart is no longer used — Dawn cart handles its own rendering
function buildCart() {}

// Cart icon — open Dawn cart
$(".header__icon--cart").click(function (evt) {
  evt.preventDefault();
  openSlideCart();
});

$(document).on("click", ".bdp_atc_quiz", function () {
  var variantId = $(this).attr("data-id");
  setTimeout(function() {
    fireAddToCart(variantId);
  }, 3000);
});

$(document).on("click", ".nrcs_checking", function () {
  $(this).toggleClass("disabled");
});

if ($(".cd_upsells_carousel").length) {
  $(".cd_upsells_carousel").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    prevArrow: "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0585/4910/8913/files/Group_4635.png?v=1732704079'/></button>",
    nextArrow: "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0585/4910/8913/files/Group_4635.png?v=1732704079'/></button>",
  });
}

$(document).on("click", ".cd_atc_ox", function (evt) {
  evt.preventDefault();
  var currentId = $(this).attr("data-id");
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: { items: [{ id: currentId, quantity: 1 }] },
    dataType: "json",
    success: function (data) {
      fireAddToCart(currentId);
      openSlideCart();
    },
    error: function () {
      alert("Error adding the items to the cart.");
    }
  });
});

function addClassicItem() {
  var currentQty = $(".quantity__input").val();
  var currentId = $(".product-variant-id").attr("value");

  jQuery.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: { id: currentId, quantity: currentQty },
    dataType: "json",
    success: function () {
      fireAddToCart(currentId);
      openSlideCart();
    }
  });
}

// InitiateCheckout — wired to Dawn cart checkout button
$(document).on('click', '#CartDrawer-Checkout', function () {
  jQuery.getJSON('/cart.js', function(cart) {
    var ids = cart.items.map(function(item) { return String(item.id); });
    fbq('track', 'InitiateCheckout', {
      content_ids: ids,
      content_type: 'product',
      value: (cart.total_price / 100).toFixed(2),
      currency: 'USD',
      num_items: cart.item_count
    });
  });
  captureMetaAttributes(function() {
    window.location.href = "/checkout";
  });
});

$(document).on("click", ".cb_atc_btn", function (evt) {
  evt.preventDefault();
  var dataId = $(this).attr("data-id");
  jQuery.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: { id: dataId, quantity: 1 },
    dataType: "json",
    success: function () {
      fireAddToCart(dataId);
      setTimeout(function () { openSlideCart(); }, 1000);
    }
  });
});

$(document).on("click", ".pdp-upsell__add-button", function () {
  addUpsellToCart($(this).attr("data-variant-id"));
});

function addUpsellToCart(variantId) {
  $.post("/cart/add.js", { items: [{ id: variantId, quantity: 1 }] })
    .done(() => {
      fireAddToCart(variantId);
      openSlideCart();
    })
    .fail(() => console.error("Error adding item to cart"));
}

// ---------------- Cart open/close ----------------
function openSlideCart() {
  fetch('/?sections=cart-drawer')
    .then(r => r.json())
    .then(data => {
      if (data['cart-drawer']) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(data['cart-drawer'], 'text/html');
        const newInner = doc.querySelector('.drawer__inner');
        const currentInner = document.querySelector('#CartDrawer .drawer__inner');
        if (newInner && currentInner) currentInner.innerHTML = newInner.innerHTML;
        const newCartDrawer = doc.querySelector('cart-drawer');
        const currentCartDrawer = document.querySelector('cart-drawer');
        if (newCartDrawer && currentCartDrawer) {
          currentCartDrawer.classList.toggle('is-empty', newCartDrawer.classList.contains('is-empty'));
        }
        const newItems = doc.querySelector('cart-drawer-items');
        const currentItems = document.querySelector('cart-drawer-items');
        if (newItems && currentItems) {
          currentItems.classList.toggle('is-empty', newItems.classList.contains('is-empty'));
        }
      }
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) cartDrawer.open();
    })
    .catch(() => {
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) cartDrawer.open();
    });
}

function closeSlideCart() {
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) cartDrawer.close();
}

// ---------------- Cart Downgrade Offer ----------------
function toggleDowngrade(btn) {
  const panel = btn.nextElementSibling;
  const icon = btn.querySelector('.cart-downgrade__icon');
  const isOpen = panel.style.display !== 'none';
  panel.style.display = isOpen ? 'none' : 'block';
  icon.textContent = isOpen ? '+' : '−';
}

function swapToOTP(btn) {
  const container = btn.closest('.cart-downgrade');
  const subVariantId = container.getAttribute('data-sub-variant');
  const subPlanId = container.getAttribute('data-sub-plan');

  sessionStorage.setItem('sub_variant_id', subVariantId);
  sessionStorage.setItem('sub_plan_id', subPlanId);

  btn.textContent = 'Switching...';
  btn.disabled = true;

  fetch('/cart/clear.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' }
  })
  .then(() => fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: 47309871251633, quantity: 1 }] })
  }))
  .then(() => openCart())
  .catch(() => {
    btn.textContent = 'Switch to one-time purchase';
    btn.disabled = false;
  });
}

function swapBackToSub() {
  const subVariantId = sessionStorage.getItem('sub_variant_id');
  const subPlanId = sessionStorage.getItem('sub_plan_id');

  if (!subVariantId || !subPlanId) return;

  fetch('/cart/clear.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' }
  })
  .then(() => fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      items: [{
        id: parseInt(subVariantId),
        quantity: 1,
        selling_plan: parseInt(subPlanId)
      }]
    })
  }))
  .then(() => {
    sessionStorage.removeItem('sub_variant_id');
    sessionStorage.removeItem('sub_plan_id');
    openCart();
  })
  .catch(err => console.error('Swap back error:', err));
}

window.cart_open = openSlideCart;
window.cart_close = closeSlideCart;
window.cart_build = buildCart;